// Legal entity and contact details, shown in the footer, Contact, Terms and Privacy pages.
// Have a qualified lawyer review the Terms and Privacy pages before launch.
export const COMPANY = {
  name: 'Public Health Solution LLC',
  street: '2003 Plank Road #1283',
  city: 'Fredericksburg, VA 22401',
  country: 'United States',
  email: 'support@icdcodefinder.com',
  phone: '540-322-7406',
  phoneHref: 'tel:+15403227406',
  governingLaw: 'the Commonwealth of Virginia, United States',
  courts: 'the City of Fredericksburg, Virginia (state courts) or the U.S. District Court for the Eastern District of Virginia (federal courts)',
};

export const COMPANY_ADDRESS = `${COMPANY.street}, ${COMPANY.city}`;

// Service providers (sub-processors) that may process personal data on our behalf. Shown on the Privacy page.
// AI providers receive de-identified text only. Keep in sync with the services actually configured.
export const SUB_PROCESSORS = [
  { name: 'Render', purpose: 'Application and website hosting', data: 'All data sent to and from our servers while requests are processed', location: 'United States' },
  { name: 'MongoDB Atlas', purpose: 'Database hosting', data: 'Account, code sets, favorites, history, usage records', location: 'United States' },
  { name: 'Stripe', purpose: 'Payments, subscriptions and the billing portal', data: 'Billing name, email, card details (held by Stripe, not us), invoices', location: 'United States' },
  { name: 'Hostinger', purpose: 'Email: sending and receiving support, account and billing emails', data: 'Email address, name, message content', location: 'United States' },
  {
    name: 'Anthropic',
    purpose: 'Hosted AI features (all plans): code suggestions, queries, explanations and guideline answers',
    data: 'Text you submit to an AI tool, after identifiers are removed (de-identified)',
    location: 'United States',
  },
  {
    name: 'OpenAI',
    purpose: 'Embeddings for semantic search and guidelines retrieval; backup AI provider, only if enabled by us',
    data: 'De-identified text you submit; short search phrases',
    location: 'United States',
  },
  { name: 'Google', purpose: 'Optional “Sign in with Google”', data: 'Name, email address and Google account ID', location: 'United States' },
  { name: 'Microsoft', purpose: 'Optional “Sign in with Microsoft”, if enabled', data: 'Name, email address and Microsoft account ID', location: 'United States' },
  { name: 'SendGrid (Twilio), if enabled', purpose: 'Bulk newsletter delivery', data: 'Email address, name', location: 'United States' },
];
